import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoSliderPageWidthLayout = loadable(
  () => import(/* webpackChunkName: "content/guest/header/photoSliderPageWidth" */ './PhotoSliderPageWidth'),
  'PhotoSliderPageWidthLayout',
);
